//all user who login to trr org chart
const initState = null;

const userAccessType = (state = initState, action) => {
    // console.log(action
    switch (action.type) {
        case 'SET_USER_ACCESS_TYPE':
            state = action.accessType;                  
            return state;
        default: return state;
    }
};

export default userAccessType;